import { Row, Col, Card } from "antd";
import { Shield, Sparkles, Building2, UserCheck, Leaf, Heart, ArrowRight } from "lucide-react";
import { motion } from "motion/react";

const ease = [0.22, 1, 0.36, 1];

const reasons = [
  { icon: UserCheck, title: "Expert Doctors", desc: "Experienced Ayurvedic specialists providing personalized treatment." },
  { icon: Leaf, title: "Authentic Medicine", desc: "Pure herbal formulations prepared using traditional Ayurvedic methods." },
  { icon: Building2, title: "Modern Facilities", desc: "Comfortable treatment rooms with advanced wellness infrastructure." },
  { icon: Heart, title: "Personalized Care", desc: "Every patient receives an individualized wellness treatment plan." },
  { icon: Sparkles, title: "Natural Healing", desc: "Holistic therapies that heal the body, mind, and spirit naturally." },
  { icon: Shield, title: "Hygienic Environment", desc: "Strict hygiene standards ensure a safe and comfortable experience." },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 bg-[#faf6ee] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease }}
          className="text-center mb-20"
        >
          <p className="uppercase md:text-xl text-base font-extrabold text-brand-gold">Why VedaNova?</p>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-brand-forest">
            The Gold Standard
            <br />
            in Wellness
          </h2>
        </motion.div>

        <Row gutter={[32, 32]}>
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <Col xs={24} md={12} xl={8} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, ease, delay: index * 0.05 }}
                  whileHover={{ y: -10, scale: 1.02 }}
                  className="h-full"
                >
                  <Card className="group !rounded-3xl !border-yellow-100 !shadow-lg hover:!shadow-2xl !transition-all !duration-500 h-full">
                    <div className="w-16 h-16 rounded-full bg-yellow-100 flex items-center justify-center mb-6 group-hover:rotate-12 group-hover:scale-110 transition-all duration-500">
                      <Icon className="w-8 h-8 text-brand-gold" />
                    </div>
                    <h3 className="text-2xl font-bold text-brand-forest mb-4">{reason.title}</h3>
                    <p className="text-gray-600 leading-7 mb-6">{reason.desc}</p>
                    
                  </Card>
                </motion.div>
              </Col>
            );
          })}
        </Row>
      </div>
    </section>
  );
}
